import { Button } from '@interstate/components/Button';
import { Modal } from '@interstate/components/Modal';
import { Typography } from '@interstate/components/Typography';
import * as offerReduxActionCreators from '@makemydeal/dr-dash-store/actions/offerRedux';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as customerSpdActionCreators from '@makemydeal/dr-dash-store/actions/CustomerSpdActionCreators';
import * as editCustomerActionCreators from '@makemydeal/dr-dash-store/actions/editCustomerActionCreators';
import { dealLockHooks } from '../hooks';
import { useDispatch, useSelector } from 'react-redux';
import type { CoBuyerModalProps } from './CoBuyerModalProps';
import { CoBuyerRemoveModalFooter } from './CoBuyerRemoveModal.styles';
import { dealerSelectors } from '@makemydeal/dr-shared-store';

export const CoBuyerRemoveModal = ({ show, setShowModal }: CoBuyerModalProps) => {
    const isSpdManagementEnabled = useSelector(dealerSelectors.isSpdManagementEnabled);
    const coBuyerCommonConsumerId = useSelector(offerReduxSelectors.getCoBuyerCommonConsumerId);

    const isLocked = dealLockHooks.useIsDealLocked();

    const dispatch = useDispatch();
    return (
        <Modal
            size="small"
            id="remove-cobuyer-modal"
            data-testid="remove-cobuyer-modal"
            show={show}
            header={
                <Typography variant="h3" color="base.color.blue.700">
                    Remove Co-Buyer
                </Typography>
            }
            footer={{
                footerComponent: (
                    <CoBuyerRemoveModalFooter>
                        <Button buttonStyle="tertiary" id="cancel-btn" data-testid="cancel-btn" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>

                        <Button
                            id="remove-cobuyer-btn"
                            data-testid="remove-cobuyer-btn"
                            disabled={isLocked}
                            onClick={() => {
                                dispatch(offerReduxActionCreators.clearCoBuyer());
                                isSpdManagementEnabled &&
                                    dispatch(customerSpdActionCreators.removeCoBuyerSpd(coBuyerCommonConsumerId));
                                setShowModal(false);
                                dispatch(editCustomerActionCreators.removeCustomerToSync(coBuyerCommonConsumerId));
                            }}
                        >
                            Remove Co-Buyer
                        </Button>
                    </CoBuyerRemoveModalFooter>
                )
            }}
        >
            <Typography variant="body-md" tag="span">
                Are you sure you want to remove this co-buyer? Remember, you will still need to update this info in your credit
                portal.
            </Typography>
        </Modal>
    );
};
